import { render, staticRenderFns } from "./termsandConditions.vue?vue&type=template&id=214004ec&"
import script from "./termsandConditions.vue?vue&type=script&lang=js&"
export * from "./termsandConditions.vue?vue&type=script&lang=js&"
import style0 from "./termsandConditions.vue?vue&type=style&index=0&id=214004ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSheet,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
